<form
  [formGroup]="form"
  class="container">
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="mb-5">
        <app-question-box
          (answerSelect)="setValueToForm(form.controls.personLandHauptwohnsitz, $event.value)"
          [answers]="countryAnswerOptions"
          [id]="'country'"
          [selectedValue]="form.controls.personLandHauptwohnsitz.value"
          [title]="'bvs.calculator.person.country'"></app-question-box>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-12 col-md-9 col-lg-6">
      @if (form.controls.personLandHauptwohnsitz.value !== null) {
        <app-skipper-haftpflicht [form]="form">
        </app-skipper-haftpflicht>
        <app-skipper-rechtsschutz [form]="form">
        </app-skipper-rechtsschutz>
      }

      @if (showCalculationPremiumEnabled) {
        <div
          [ngClass]="getPremiumColorCode(skipperCalculationService.getCalculationResult())"
          class="card-body mb-4 box-shadow">
          @if (canShowCalculationsResult()) {
            <div
              class="mb-5">
              <app-premium-display
                [premiumValue]="skipperCalculationService.getCalculationResult()?.versicherungspraemieInEur!"></app-premium-display>
            </div>
          }
        </div>
      }

      <div class="mb-5 mt-5 d-flex justify-content-center">
        <button
          (click)="prev.emit()"
          class="btn btn-sm btn-secondary">
          {{ 'shared.back' | transloco }}
        </button>

        @if (this.form.controls.isKundeSkipperVertragsHaftpflichtSelected.value || this.form.controls.isKundeSkipperVertragsRechtsschutzSelected.value) {
          <button
            (click)="next.emit()"
            data-cy="continueToContract"
            class="btn btn-sm btn-primary">
            @if (this.form.controls.isKundeSkipperVertragsHaftpflichtSelected.value) {
              {{ 'bvs.calculator.continueToHaftpflichtDetails' | transloco }}
            } @else {
              {{ 'bvs.calculator.continueToRechtsschutzDetails' | transloco }}
            }
          </button>
        }
      </div>
    </div>
  </div>
</form>
